<template>
  <div>
    <form @submit.prevent="onSubmit">
      <div class="wizard-header" style="z-index: 0">
        <h3 class="wizard-title">{{ wizardTitle }}</h3>
        <p class="category">{{ wizardDescription }}</p>
      </div>
  
      <insurers></insurers>

      <wizard-navigation :step="step" v-if="selectedOccupation"></wizard-navigation>

      <div class="chat-form tab-content" :class="{ 'p-t-0-i mt-0': !selectedOccupation }">
        <div class="tab-pane" v-bind:class="{active: step == 1}" v-if="step == 1">
          <error-message></error-message>

          <div v-show="selectedOccupation">
            <div class="row">
              <div class="col-sm-12">
                <h5 class="info-text">{{ infoText }}</h5>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-sm-10 col-sm-offset-1">
                <div v-bind:class="[
									'form-group'
								]">
                  <label>
                    Email Address
                    <span class="required-field">*</span>
                  </label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Your Email Address"
                    v-model="fields.email"
                    maxlength="190"
                  />
                </div>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-sm-5 col-sm-offset-1">
                <div class="form-group">
                  <label style="width:100%;">
                    Postcode
                    <span class="required-field">*</span>
                  </label>
                  <input
                    type="number"
                    min="100"
                    max="9999"
                    class="form-control c-required"
                    name="postcode"
                    id="postcode"
                    placeholder="Your postcode..."
                    v-model="fields.postcode_of_risk"
                    @change="postCodeChanged"
                  />
                </div>
              </div>

              <div class="col-sm-5">
                <div class="form-group">
                  <label>
                    Occupation
                    <span class="required-field">*</span>
                  </label>
                  <br />
                  <p style="font-size: 14px;">
                    {{ occupationName }}
                    <a
                      href="#"
                      type="button"
                      @click.prevent="selectedOccupation = false"
                    >
                      (<i class="fas fa-pencil"></i>Change)
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-sm-5 col-sm-offset-1">
                <div
                  v-bind:class="[
									'form-group',
									{
										'has-error': (
											errors.current_annual_revenue &&
											(
												errors.current_annual_revenue.out_of_range ||
												errors.current_annual_revenue.quote_rejected
											)
										)
									}
								]"
                >
                  <label>
                    Annual Revenue
                    <span class="required-field">*</span>
                  </label>

                  <vue-numeric
                    v-model="fields.current_annual_revenue"
                    v-bind:min="0"
                    v-bind:minus="false"
                    v-bind:precision="2"
                    output-type="Number"
                    class="form-control"
                    placeholder="Annual Revenue"
                    @input="annualRevenueInput"
                  />

                  <!-- <select class="form-control" v-model="fields.current_annual_revenue">
									<option value="">- Please choose annual revenue -</option>
									<option v-for="(revenueValue, revenueKey) in configs.current_annual_revenue" :value="revenueKey">
										{{ revenueValue }}
									</option>
                  </select>-->
                </div>
                <p
                  class="alert alert-warning"
                  v-if="errors.current_annual_revenue && errors.current_annual_revenue.quote_rejected"
                >Online quote unavailable for the selected annual revenue.</p>
              </div>

              <div class="col-sm-5">
                <div
                  v-bind:class="[
									'form-group',
									{
										'has-error': (
											errors.head_count &&
											errors.head_count.quote_rejected
										)
									}
								]"
                >
                  <label for="number_of_staff">
                    Number of Staff
                    <span class="required-field">*</span>
                  </label>
                  <select class="form-control" v-model="fields.head_count">
                    <option value>- Please choose number of staff -</option>
                    <option
                      v-for="headCountIndex in maxHeadCount"
                      :key="headCountIndex"
                      :value="headCountIndex"
                    >{{ headCountIndex }}{{ headCountIndex > 10 ? '+' : '' }}</option>
                  </select>
                </div>
                <p
                  class="alert alert-warning"
                  v-if="errors.head_count && errors.head_count.quote_rejected"
                >Online quote unavailable for the selected number of staff.</p>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-sm-5 col-sm-offset-1">
                <div>
                  <label>
                    Percentage of work by sub-contractors
                    <span class="required-field">*</span>
                  </label>
                  <select
                    class="form-control"
                    v-model="fields.percentage_of_insured_turnover_from_by_sub_contractors"
                  >
                    <option value>- Please choose percentage of work -</option>
                    <option
                      v-for="(value, key) in configs.percentage_of_insured_turnover_by_sub_contractors"
                      :key="key"
                      :value="key"
                    >{{ value.value }}</option>
                  </select>
                </div>

                <p
                  class="alert alert-warning"
                  v-if="(
									errors.percentage_of_insured_turnover_from_by_sub_contractors &&
									errors.percentage_of_insured_turnover_from_by_sub_contractors.quote_rejected
								)"
                >Online quote unavailable for the selected percentage of work by sub-contractors.</p>
              </div>

              <div class="col-sm-5">
                <div
                  v-bind:class="[
									'form-group',
									{
										'has-error': (
											errors.percentage_of_insured_turnover_from_premises &&
											errors.percentage_of_insured_turnover_from_premises.quote_rejected
										)
									}
								]"
                >
                  <label>
                    Heat work percentage
                    <span
                      class="required-field"
                      v-if="requireHeatWorkPercentage"
                    >*</span>
                    <span
                      class="ti-info-alt"
                      v-tooltip="{
										content: 'The percentage of welding and heat/hot works done onsite away from your premises.',
										placement: 'bottom'
									}"
                    />
                  </label>
                  <select
                    class="form-control"
                    v-on:change="percentageOfInsuredTurnoverFromPremisesChanged()"
                    v-model="fields.percentage_of_insured_turnover_from_premises"
                  >
                    <option value>- Please choose heat work percentage -</option>
                    <option
                      v-for="(value, key) in configs.percentage_of_insured_turnover_heat_work_away_from_premises"
                      :key="key"
                      :value="key"
                    >{{ value.value }}</option>
                  </select>
                </div>

                <p
                  class="alert alert-simple"
                  v-if="showPercentageOfInsuredTurnoverFromPremisesWarning"
                >In the event of a loss due to heat a $1,000 excess will be applied.</p>
                <p
                  class="alert alert-warning"
                  v-if="(
									errors.percentage_of_insured_turnover_from_premises &&
									errors.percentage_of_insured_turnover_from_premises.quote_rejected
								)"
                >Online quote unavailable for the selected heat work percentage.</p>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-sm-5 col-sm-offset-1">
                <div class="form-group">
                  <label for>
                    How did you hear about us?
                    <span class="required-field">*</span>
                  </label>
                  <select name="referral" class="form-control" v-model="fields.referral" required>
                    <option value selected disabled>-- Select Option --</option>
                    <option value="tv">TV Commercial</option>
                    <option value="google">Google Search</option>
                    <option value="bing">Bing Search</option>
                    <option value="referred_by_someone">Referred by Someone</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                  <label>
                    Required Public Liability Amount
                    <span class="required-field">*</span>
                  </label>
                  <br />
                  <button-group
                    :values="fields.amount_options"
                    :value="fields.limits_required"
                    :name="'limits_required'"
                    v-on:change="fields.limits_required = $event"
                  />
                </div>
              </div>
            </div>

            <!-- <div class="row justify-content-center">
              <div class="col-sm-5 col-sm-offset-1">
                <div class="form-group">
                  <label>
                    Required Public Liability Amount
                    <span class="required-field">*</span>
                  </label>
                  <br />
                  <button-group
                    :values="fields.amount_options"
                    :value="fields.limits_required"
                    :name="'limits_required'"
                    v-on:change="fields.limits_required = $event"
                  />
                </div>
              </div>

              <!-- <div class="col-sm-5">
                <div class="form-group">
                  <label>
                    Deductible (
                    <em>Excess</em>)
                    <span class="required-field">*</span>
                  </label>
                  <br />
                  <button-group
                    :values="fields.deductible_options"
                    :value="fields.deductible"
                    :name="'deductible'"
                    v-on:change="fields.deductible = $event"
                  />
                </div>
              </div> --
            </div> -->

            <div
              class="row justify-content-center"
              v-if="state === 'NSW' && fields.current_annual_revenue < 2000000"
            >
              <div class="col-sm-10 col-sm-offset-1">
                <h5 class="info-text text-center">Stamp Exemption Eligibility</h5>

                <div class="alert alert-info alert-simple">
                  <p>I hereby declare that I am a Capital Gains Tax small business entity (within the meaning of section 152-10 (1AA) of the Income Tax Assessment Act 1997 of the Commonwealth). I am a small business individual/partnership/company and/or trust, which is carrying on business, and the business has an aggregated turnover of less than $2 million.</p>

                  <div class="form-group m-t-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="abn"
                      placeholder="Enter ABN (Optional)"
                    />
                  </div>

                  <div class="form-group m-t-10">
                    <label style="color:#00a99d;">
                      <input type="checkbox" v-model="fields.agreed_to_declaration" /> I agree this declaration is correct & claim my discount.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <occupation-choice
            v-on:updateOccupation="selectOccupation"
            v-on:confirmOccupation="selectedOccupation = true"
            v-show="!selectedOccupation"
          />
        </div>
      </div>

      <div class="wizard-footer d-flex justify-content-between" style="padding-top: 20px">
        <div class="pull-left col-md-6" v-if="selectedOccupation">
          <button type="button" class="btn btn-default btn-wd" @click="removeOccupation">
            <i class="fas fa-arrow-left"></i> Change Occupation
          </button>
        </div>
        <div class="pull-right col-md-6 d-flex justify-content-end" v-if="selectedOccupation">
          <div class=" p-t-10 m-r-10 text-center">
            <div
              v-if="!enableNextButton && calculating && !showScreenLoader"
              class="loading-box m-b-4-i m-r-10"
            />
            <label
              v-else-if="!enableNextButton && !showScreenLoader"
            >Please fill in ALL required fields to proceed</label>
          </div>
          <button
            type="button"
            class="btn btn-next btn-fill btn-success btn-wd"
            :disabled="!enableNextButton"
            @click="submitForm"
          >
            Next
            <i class="fa fa-arrow-right"></i>
          </button>

        </div>
      
        <div class="clearfix"></div>
      </div>
    </form>
  </div>
</template>

<script>
import VueNumeric from "vue-numeric";
import OccupationChoice from "./OccupationChoice";
import ButtonGroup from "./ButtonGroup";
import WizardNavigation from "./WizardNavigation";

import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import store from "../store";
import { isEmpty, find, pick, get } from "lodash";
import * as appConfigs from "../configs";
import axios from "axios";
import Cookies from "js-cookie";
import {
  generateErrorMessage,
  formValidate,
  requireHeatWorkPercentage,
} from "../helpers";

export default {
  store,
  props: ["wizardTitle", "wizardDescription", "infoText", "affiliate"],
  components: {
    OccupationChoice,
    VueNumeric,
    ButtonGroup,
    WizardNavigation

  },
  data: function () {
    return {
      // fields needed to be post to api end point
      fields: {
        email: "",
        postcode_of_risk: "",
        occupation_id: "",
        current_annual_revenue: "",
        head_count: "",
        percentage_of_insured_turnover_from_premises: "",
        percentage_of_insured_turnover_from_by_sub_contractors: "",
        period_of_cover: "12",
        limits_required: appConfigs.defaultAmountOption,
        deductible: "1000",
        amount_options: appConfigs.amountOptions,
        deductible_options: appConfigs.deductibleOptions.def,
        referral: "",
        agreed_to_declaration: null,
        affiliate_id: null,
        id: null,
      },
      abn: "",
      state: null,
      selectedOccupation: false,
      chat_type: null,
      occupationName: null,
      finishedCalculating: false,
      existingPendingOrderId: null,
      formLoading: true,
    };
  },
  watch: {
    serializedFields: function () {
      this.finishedCalculating = false;
      this.calculatePrice();
    },
    finishedCalculating(value) {
      if (value) {
        this.createPendingOrder();
      }
    },
    "fields.agreed_to_declaration"(value) {
      this.setAgreedToDeclaration({ trueOrFalse: value });
    },
    fields: {
      handler(val){
        // console.log("Change Detected.");
        this.$store.commit("setCalculating", { calculating: true });
      },
      deep: true
    },
  },
  computed: {
    maxHeadCount() {
      return appConfigs.maxHeadCount;
    },
    pendingOrderId() {
      if (typeof Cookies.get("pendingOrderId") != "undefined") {
        return Cookies.get("pendingOrderId");
      }
      return false;
    },
    serializedFields() {
      return JSON.stringify(this.fields);
    },
    enableNextButton() {
      return (
        this.isValidForm &&
        this.summaryData &&
        !this.quoteRejected &&
        !this.calculating && 
        !this.formLoading
      );
    },
    isValidForm() {
      const errors = formValidate(this.fields, {
        percentage_of_insured_turnover_from_premises: this.requireHeatWorkPercentage,
        affiliate_id: false
      });
      this.$store.commit("setErrors", { errors });
      return isEmpty(errors);
    },
    showPercentageOfInsuredTurnoverFromPremisesWarning() {
      return this.fields.percentage_of_insured_turnover_from_premises == "0-5";
    },
    disableEmailField() {
      return this.existingPendingOrderId || this.pendingOrderId;
    },
    requireHeatWorkPercentage() {
      return requireHeatWorkPercentage(
        this.fields.occupation_id,
        this.configs.occupations
      );
    },
    ...mapState({
      configs: (state) => state.configs,
      step: (state) => state.step,
      prevStep: (state) => state.prevStep,
      quoteRejected: (state) => state.quoteRejected,
      summaryData: (state) => state.summaryData,
      calculating: (state) => state.calculating,
      showEmailBlock: (state) => state.showEmailBlock,
      customerEmail: (state) => state.customerEmail,
      agreedToTerms: (state) => state.agreedToTerms,
      existingPendingOrder: (state) => state.existingPendingOrder,
      stateByPostcode: (state) => state.stateByPostcode,
      agreedToDeclaration: (state) => state.agreedToDeclaration,
      errors: (state) => state.errors,
      pendingOrder: (state) => state.pendingOrder,
      showScreenLoader: (state) => state.showScreenLoader,
    }),
  },
  beforeMount() {
    let vm = this;
    // not the best solution, but due to some unknow issue,
    // if the vm.checkAndLoadPendingOrder() was called
    // directly, sometimes vue fields data was initalized , sometimes not
    setTimeout(function () {
      vm.checkAndLoadPendingOrder();
    }, 1000);
  },
  mounted() {
    this.fields.affiliate_id = this.affiliate;
   
  },
  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      calculate: "calculate",
    }),
    ...mapMutations({
      toggleShowEmailBlock: "toggleShowEmailBlock",
      setAgreedToTerms: "setAgreedToTerms",
      updateExistingPendingOrderId: "updateExistingPendingOrderId",
      updateSelectedOccupation: "updateSelectedOccupation",
      setAgreedToDeclaration: "setAgreedToDeclaration",
      updateStateByPostcode: "updateStateByPostcode",
    }),
    selectOccupation(occupation) {
      this.occupationName = occupation.business_activity;
      this.fields.occupation_id = occupation.id;
    },
    postCodeChanged() {
      this.formLoading = true;
      axios
        .post(appConfigs.checkPostCodeUrl, {
          postcode_of_risk: this.fields.postcode_of_risk,
        })
        .then((response) => {
          this.state = response.data.state;
          this.formLoading = false;
        })
        .catch((error) => {
          this.state = null;
        });
    },
    annualRevenueInput() {
      this.formLoading = true;
      const value = String(this.fields.current_annual_revenue);
      const limit = 8;
      if (value.length > limit) {
        this.fields.current_annual_revenue = Number(value.slice(0, limit));
      }
      this.formLoading = false;

    },
    createPendingOrder() {
      // Once email has been provided and price calculated, create a pending order with the customer
      if (
        !this.isValidForm ||
        this.pendingOrderId ||
        this.existingPendingOrderId
      ) {
        return;
      }

      axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          ...this.summaryData,
          step: 1,
          chat_type: this.chat_type,
          existingPendingOrderId: this.existingPendingOrderId,
        })
        .then((response) => {
          const pendingOrder = get(
            response,
            "data.pendingOrder",
            this.pendingOrder
          );
          Cookies.set("pendingOrderId", pendingOrder.id);
          this.existingPendingOrderId = pendingOrder.id;
          this.updateExistingPendingOrderId({
            existingPendingOrder: this.existingPendingOrderId,
          });
          this.$store.commit("setPendingOrder", { pendingOrder });
          this.$store.commit("setCalculating", { calculating: false });
        })
        .catch((error) => {
          alert("There was an error creating a pending order", error);
        });
    },
    calculatePrice: _.debounce(function () {
      if (!this.isValidForm) {
        return;
      }
      this.formLoading = true;
      this.$store.commit("setCalculating", { calculating: true });

      this.calculate(this.fields)
        .then((data) => {
          this.$store.commit("setSummaryData", { summaryData: data });
          this.state = data.state;
          this.updateStateByPostcode({ stateByPostcode: data.state });

          this.$store.commit("clearError");
          if (this.pendingOrderId) {
            this.$store.commit("setCalculating", { calculating: false });
          }
          this.finishedCalculating = true;
          this.formLoading = false;

        })
        .catch((error) => {
          this.$store.commit("setCalculating", { calculating: false });
          if (error.response?.data.rejectQuote) {
            this.$store.commit("setQuoteRejected", { quoteRejected: true });
          }
          this.$store.commit("setSummaryData", { summaryData: false });
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
        });
    }, 1000),
    checkAndLoadPendingOrder() {
      const fields = Object.keys(this.fields);
      let orderId = this.pendingOrder?.id;

      if (orderId == undefined || orderId == null) {
        return;
      }

      this.$store.commit("setScreenLoader", { showScreenLoader: true });
      this.loadPendingOrder({ orderId })
        .then((data) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.fields = Object.assign({}, this.fields, pick(data, fields));
          this.loadPendingOrderOccupation(data.occupation_id);
          this.abn = data.abn;
          this.selectedOccupation = true;
          this.updateSelectedOccupation({
            selectedOccupation: this.selectedOccupation,
          });
          this.updateExistingPendingOrderId({ existingPendingOrder: data.id });
          this.setAgreedToTerms({ trueOrFalse: true });

          if (!this.prevStep) {
            let step = data.step;
            if(data.step <= 3){
              step = 1;
            }
            this.$store.commit("setStep", { step });
          }
        })
        .catch(() => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },
    submitForm: function () {
      if (!this.enableNextButton) {
        return;
      }

      if (this.fields.agreed_to_declaration === null) {
        this.fields.agreed_to_declaration = false;
      }

      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          ...this.summaryData,
          abn: this.abn,
          step: this.step,
          referral: this.fields.referral, // ???
          id: this.pendingOrderId,
          existingPendingOrderId: this.existingPendingOrderId,
        })
        .then((response) => {
          const pendingOrder = get(
            response,
            "data.pendingOrder",
            this.pendingOrder
          );
          Cookies.set("pendingOrderId", pendingOrder.id);
          this.$store.commit("incrementStep");
          this.$store.commit("clearError");
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setPendingOrder", { pendingOrder });
          this.scrollToTop();
        })
        .catch((error) => {
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },
    percentageOfInsuredTurnoverFromPremisesChanged: function () {
      if (this.fields.percentage_of_insured_turnover_from_premises == "0-5") {
        this.fields.deductible = 1000;
      }
    },
    loadPendingOrderOccupation(id) {
      let occupation = find(this.configs.occupations, (o) => {
        return o.id === id;
      });

      if (occupation) {
        this.occupationName = occupation.business_activity;
        return;
      }
      this.selectedOccupation = false;
    },
    removeOccupation() {
      this.selectedOccupation = false;
      this.updateSelectedOccupation({ occupation: false });
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/form/global";

.m-b-0-i {
  margin-bottom: 0 !important;
}

.m-b-4-i {
  margin-bottom: 4px !important;
}

.p-t-0-i {
  padding-top: 0 !important;
}
.multiselect__option {
  white-space: pre-wrap !important;
}
@media screen and (max-width: 480px) {
  .chat-form {
    .multiselect__content-wrapper {
      top: 90px !important;
    }
    .multiselect__input {
      top: 30px !important;
      width: 100vw !important;
      height: 60px;
      position: absolute;
      left: 0px;
      z-index: 10000;
    }
  }
}
</style>
